import { useState, useRef, useCallback } from 'react';

function useStateRef(initialValue: any) {
    const [state, setState] = useState(initialValue);
    const ref = useRef(initialValue);

    // 包装 setState，每次更新 state 的同时同步更新 ref
    const setStateAndRef = useCallback((newValue: any) => {
        if (typeof newValue === 'function') {
            // 支持函数式更新 setState(prev => ...)
            setState((prev: any) => {
                const next = newValue(prev);
                ref.current = next;
                return next;
            });
        } else {
            ref.current = newValue;
            setState(newValue);
        }
    }, []);

    return [state, ref, setStateAndRef];
}

export default useStateRef; 